var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"box"},[_c('v-toolbar',{staticClass:"toolbar",attrs:{"flat":"","dense":""}},[_c('v-toolbar-title',[_c('strong',[_vm._v(" Edit Quiz ")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }